import axios from "axios";
import { backendUrl } from "./backendUrl";

export const API = `${backendUrl}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const DEFAULT_API_ERROR = "Something went wrong. Please try again.";

export function apiError(detail, fallback = DEFAULT_API_ERROR) {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail.trim() || fallback;
  if (Array.isArray(detail)) {
    const messages = detail.map((entry) => apiError(entry, "")).filter(Boolean);
    return messages.join(" ") || fallback;
  }
  if (detail instanceof Error) return detail.message || fallback;
  if (typeof detail === "object") {
    for (const key of ["message", "msg", "detail", "error"]) {
      if (detail[key] !== undefined && detail[key] !== detail) {
        const message = apiError(detail[key], "");
        if (message) return message;
      }
    }
    if (Array.isArray(detail.errors)) return apiError(detail.errors, fallback);
  }
  return fallback;
}

export function apiFieldErrors(detail) {
  if (!detail) return {};
  if (!Array.isArray(detail) && typeof detail === "object" && detail.field) {
    return { [detail.field]: apiError(detail.message || detail.msg, "") };
  }
  const rows = Array.isArray(detail) ? detail
    : Array.isArray(detail?.errors) ? detail.errors : [];
  return rows.reduce((fields, row) => {
    const location = Array.isArray(row?.loc) ? row.loc : [];
    const field = [...location].reverse().find((part) => typeof part === "string" && part !== "body");
    if (field) fields[field] = apiError(row?.msg || row?.message, "");
    return fields;
  }, {});
}

export default api;
